export enum StoreItemTagEnum {
  Best = 'BEST',
  Primium = '프리미엄',
  Sale = 'SALE',
  Popular = '인기',
  SpecialPrice = '특가',
  FreeDelivery = '무료배송',
}
